import React from "react"
import RatingAsset from "../../svg/RatingIcon.svg"
import TrustPilotFallbackRating from "./trust-pilot-rating.component"
import { TrustPilotFallbackLightTheme } from "./trust-pilot.styles"

const TrustPilotGeneralLightTheme = () => {
    return (
        <div style={{ position: "relative" }}>
            <div
                className="trustpilot-widget"
                data-locale="en-US"
                data-template-id="5419b637fa0340045cd0c936"
                data-businessunit-id="634c923bc5267b8afde2a603"
                data-theme="light"
                data-style-height="25px"
            >

                <TrustPilotFallbackLightTheme>
                    <RatingAsset style={{ marginRight: "10px", display: "flex", marginLeft: "-5px" }} />
                    <TrustPilotFallbackRating />
                </TrustPilotFallbackLightTheme>

            </div>

            <a href="https://www.trustpilot.com/review/zerotomastery.io"
                target="_blank"
                rel="noopener"
                aria-label="Trustpilot reviews for Zero To Mastery"
                style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "50px",
                    zIndex: 2,
                    display: "block",
                }}
            />
        </div>
    )
}

export default TrustPilotGeneralLightTheme